<template>
  <stepper-layout
    :stepTitle="'Add Merchandise'"
    :stepIcon="'lock'"
  >
    <div v-for="(item, i) in merchandiseList" :key="i">
      <v-layout align-center justify-space-between class="py-3">
        <v-flex>
          <div class="text-h6 mb-2">{{ item.name }}</div>
          <div class="subheading">${{ parseFloat(item.price).toFixed(2) }}/ea.</div>
        </v-flex>
        <v-layout justify-end>
          <v-btn
            data-testid="remove-merchandise-btn"
            class="remove-merchandise-btn error"
            small
            fab
            :disabled="!item.quantity"
            @click="remove(item)"
          >
            <v-icon>remove</v-icon>
          </v-btn>
          <v-card class="px-3 mx-2">
            <v-layout align-center class="text-h5 pt-2">
              {{ item.quantity }}
            </v-layout>
          </v-card>
          <v-btn
            data-testid="add-merchandise-btn"
            class="add-merchandise-btn success"
            small
            fab
            @click="add(item)"
          >
            <v-icon>add</v-icon>
          </v-btn>
        </v-layout>
      </v-layout>
      <v-divider />
    </div>
    <v-banner v-if="!merchandiseList.length" class="text-h6">
      <v-icon>error</v-icon>
      No merchandise found for this facility.
    </v-banner>
  </stepper-layout>
</template>

<script>
import StepperLayout from "@/layouts/StepperLayout";
export default {
  methods: {
    add(merchandise) {
      merchandise.quantity++;
      this.updateCart(merchandise);
    },
    remove(merchandise) {
      merchandise.quantity--;
      this.updateCart(merchandise);
    },
    updateCart() {
      const filteredList = this.merchandiseList.filter(item => item.quantity);
      this.$store.commit("updateMerchandiseCart", filteredList);
      clearTimeout(this.getCostTimeout);
      this.getCostTimeout = setTimeout(() => {
        this.$emit("getMoveInCost");
      }, 500);
    }
  },
  computed: {
    merchandiseList() {
      return this.$store.state.facilities.facilityMerchandise;
    }
  },
  components: { StepperLayout }
};
</script>
